
export const formFields = {
  attrName: {
    key: 'attrName',
    type: 'text',
    label: 'Attributes Name',
    required: true,
    placeholder: '',
    requiredMessage: 'This field is required.',
    displayLayout: 'col-md-7',
    tooltip: '<div> Attributes Name </div>',
    maxLength: 50,
    maxLengthMessage: 'maximum 30 charactors allowed.',
    pattern: /^(?=.*?[A-Za-z]).{1,}$/,
    spaceNotAllowed: true,
  },
  // platformId: {
  //   key: 'platformId',
  //   label: 'Platform',
  //   required: true,
  //   placeholder: '',
  //   requiredMessage: 'This field is required.',
  //   displayLayout: 'col-md-7',
  //   textKey: 'name'
  // }
};

export const confirmationMessage = {
  action: {
    confirmationMessage: `Kindly let us know if you'd like to save your changes.`,
    type: 'Confirmation'
  }
};

export const successfullyMessage = {
  action: {
    confirmationMessage: 'Successfully Saved Variable',
    type: 'alert',
  }
};

export const attributeAlreadyExistsMessage = {
  action: {
    confirmationMessage: 'Attribute already exists',
    type: 'alert',
  }
};

export const emptyAttributeMessage = {
  action: {
    confirmationMessage: 'Enter at least one value',
    type: 'error',
  }
};
